import React from "react";
import { motion } from "framer-motion";
import { SCENES, OFFSETS } from "@/data/adPackage";
import { onScreenText } from "@/lib/downloads";
import { Clock, Film } from "lucide-react";

export default function Storyboard() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
      {SCENES.map((s, i) => {
        const start = OFFSETS.map[s.id];
        const texts = onScreenText(s).filter(Boolean);
        return (
          <motion.article
            key={s.id}
            data-testid={`storyboard-scene-${i + 1}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: (i % 2) * 0.08 }}
            className={`group relative rounded-2xl overflow-hidden bg-neutral-950 border border-white/10 ${
              i === 0 || i === SCENES.length - 1 ? "md:col-span-2" : ""
            }`}
          >
            <div className={`relative ${i === 0 || i === SCENES.length - 1 ? "aspect-[21/9]" : "aspect-video"} overflow-hidden`}>
              <img
                src={s.image}
                alt={s.chapter}
                className="w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              <div className="absolute top-3 left-3 flex items-center gap-2">
                <span className="flex items-center justify-center w-8 h-8 rounded-lg brand-gradient font-display font-black text-white text-sm">
                  {s.index}
                </span>
                <span className="glass rounded-full px-3 py-1 text-xs font-semibold text-white flex items-center gap-1.5">
                  <Clock className="w-3 h-3 text-orange-400" /> {start}s – {start + s.dur}s
                </span>
              </div>
              <div className="absolute bottom-3 left-4 right-4">
                <h3 className="font-display font-black text-white text-xl sm:text-2xl tracking-tight">{s.chapter}</h3>
              </div>
            </div>
            <div className="p-4 sm:p-5 space-y-3">
              <div>
                <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.18em] text-orange-400 font-semibold mb-1">
                  <Film className="w-3 h-3" /> Visual
                </div>
                <p className="text-sm text-neutral-400 leading-relaxed">{s.shot}</p>
              </div>
              <div>
                <div className="text-[10px] uppercase tracking-[0.18em] text-orange-400 font-semibold mb-1">Voice-Over</div>
                <p className="text-sm text-white/90 italic leading-relaxed">“{s.vo}”</p>
              </div>
              <div>
                <div className="text-[10px] uppercase tracking-[0.18em] text-orange-400 font-semibold mb-1.5">On-Screen Text</div>
                <div className="flex flex-wrap gap-1.5">
                  {texts.map((tx, k) => (
                    <span key={k} className="text-[11px] font-medium text-neutral-200 bg-white/5 border border-white/10 rounded-md px-2 py-1">
                      {tx}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </motion.article>
        );
      })}
    </div>
  );
}
